import React from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import FormWrapper from '../../../../Components/Form/FormWrapper';
import * as yup from 'yup';
import InputField from '../../../../Components/Form/components/InputField';
import SubmitButton from '../../../../Components/Button/SubmitButton';
import PhoneNumberField from '../../../../Components/PhoneNumber/PhoneNumberField';
import { useAppContext } from '../../../../Services/AppContext';
import ImageUploadField from '../../../Base/Components/Inputs/ImageUploadField/ImageUploadField';

export interface UserSettingsProfileFormValues {
	salutationBefore?: string;
	salutationAfter?: string;
	firstName: string;
	lastName: string;
	email: string;
	phone?: string;
	avatar?: string;
}

export interface UserSettingsProfileFormDefaultValues
	extends Omit<
		UserSettingsProfileFormValues,
		'firstName' | 'lastName' | 'email'
	> {
	firstName?: string;
	lastName?: string;
	email?: string;
}

interface Props {
	defaultValues?: UserSettingsProfileFormDefaultValues;
	onSubmit: (values: UserSettingsProfileFormValues) => void;
}

const validationSchema = yup.object({
	salutationBefore: yup.string().notRequired().nullable(),
	salutationAfter: yup.string().notRequired().nullable(),
	firstName: yup
		.string()
		.required('validation.userSettingsProfileForm.firstName'),
	lastName: yup
		.string()
		.required('validation.userSettingsProfileForm.lastName'),
	email: yup
		.string()
		.email('validation.userSettingsProfileForm.email')
		.required('validation.userSettingsProfileForm.email'),
	phone: yup.string().nullable(),
	avatar: yup.string().notRequired().nullable(),
});

const UserSettingsProfileForm: React.FC<Props> = ({
	onSubmit,
	defaultValues,
}) => {
	const { isLatam } = useAppContext();
	const formMethods = useForm<UserSettingsProfileFormValues>({
		defaultValues,
		resolver: yupResolver(validationSchema),
	});

	return (
		<FormWrapper formMethods={formMethods}>
			<div className='row'>
				<div className='col-lg-6 col-12'>
					<InputField
						name='salutationBefore'
						label='base.shared.salutationBefore'
						isWrapped
					/>
				</div>
				{!isLatam && (
					<div className='col-lg-6 col-12'>
						<InputField
							name='salutationAfter'
							label='base.shared.salutationAfter'
							isWrapped
						/>
					</div>
				)}
			</div>
			<InputField
				name='firstName'
				label='base.shared.firstName'
				isRequired
				isWrapped
				disabled
			/>
			<InputField
				name='lastName'
				label='base.shared.lastName'
				isRequired
				isWrapped
				disabled
			/>
			<InputField
				name='email'
				label='base.shared.email'
				isRequired
				isWrapped
				disabled
			/>
			<PhoneNumberField name='phone' label='base.shared.phone' isWrapped />
			<ImageUploadField
				label='base.shared.uploadAvatarLabel'
				name='avatar'
				previewStyle={{
					height: '150px',
					width: '150px',
					borderRadius: '100%',
					overflow: 'hidden',
				}}
				isWrapped
			/>
			<div className='mt-4'>
				<SubmitButton onSubmit={onSubmit} title='base.shared.save' />
			</div>
		</FormWrapper>
	);
};

export default UserSettingsProfileForm;
